import {createActions} from 'client/framework';

export default createActions(null, [
  'REMOVE_ALIGNMENT',
  'SAVE_ALIGNMENT',
  'SET_PENDING_GUIDE_LEVEL_ID',
  'SET_PENDING_EXAM_ALIGNMENT'
]);
